import { render, staticRenderFns } from "./CreateAdWizard.vue?vue&type=template&id=90799980"
import script from "./CreateAdWizard.vue?vue&type=script&lang=js"
export * from "./CreateAdWizard.vue?vue&type=script&lang=js"
import style0 from "./CreateAdWizard.vue?vue&type=style&index=0&id=90799980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports